module.exports = __webpack_public_path__ + "static/media/carbon_circle-dash_preenchido.1f9b0e2c.svg";